module.exports = __webpack_public_path__ + "static/img/icon_10.82568f83.png";